import { View } from './view'

export const ProductCard = View
